import { Stack, StackProps, styled } from "@mui/material";

type FakeInputType = {
  error?: boolean;
};

const FakeInput = (props: StackProps & FakeInputType) => {
  return <StyledFakeInput {...props} error={props.error} />;
};

const StyledFakeInput = styled(Stack)<{ error?: boolean }>(({ error }) => ({
  padding: "9px 14px",
  border: `1px solid ${error ? "#f03e3e !important" : "#D0D5DD"}`,
  borderRadius: 8,
  ":hover": {
    borderColor: "#000",
  },
  ".hidden": {
    display: "none",
  },
  cursor: "pointer",
}));

export default FakeInput;
